import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { getUserVstLocale } from "../api/features/user/selectors";
import { useBrand } from "../../../../common/providers/brand/brand-context";
import LocaleProvider from "../../../../common/providers/LocaleProvider";
import useQueryParams from "../../../../common/ui/useQueryParams";
import { getBestLocale } from "../../../../common/utils/locale";

export default function ReduxLocaleProvider({ children }) {
  const params = useQueryParams();
  const localeFromParam = useRef(params.get("locale"));
  const brand = useBrand();
  const userLocale = useSelector(getUserVstLocale);

  const currentLocale = getBestLocale({
    queryLocale: localeFromParam.current,
    userLocale,
    brandLocale: brand.getProp("locale"),
  });

  return <LocaleProvider locale={currentLocale}>{children}</LocaleProvider>;
}
